import { AppEvent } from 'types/appEvent';
import { createReducer } from 'utils/reducer/reducerUtils';
import { CacheFlags } from 'types/cacheTypes';

export const reduceToNextInvalidatedCacheFlags = createReducer<
  CacheFlags,
  AppEvent
>((prev, event) => {
  switch (event.name) {
    case 'ProdStackManager__DataRecieved': {
      return {
        ...prev,
        prodStackManagerData: false,
      };
    }
    case 'ProdStackManager__TryOnceAgain':
      return {
        ...prev,
        prodStackManagerData: true,
      };
    default:
      return prev;
  }
});
